import React from "react";
import View from "components/vmisc/flow_preview/Board.view";


function Board({
  nodes,
  edges,
  reactFlowWrapper,
  setReactFlowInstance,
  onNodesChange,
  onEdgesChange,
  onClickConnectEdge,
  onClickUpdateEdge,
  onDropNode,
  onDragNode,
  focusedNode,
}) {

  let defaultViewport = {}
  const initialBoardZoom = 1.1;

  if (focusedNode) {
    const x = focusedNode?.position?.x??0 + 100;
    const y = focusedNode?.position?.y??0 + 25;

    defaultViewport = {
      x: -(x - 130) * initialBoardZoom,
      y: -(y - 90) * initialBoardZoom,
      zoom: initialBoardZoom
    }
  }

  return (
    <View
      nodes={nodes}
      edges={edges}
      defaultViewport={defaultViewport}
      reactFlowWrapper={reactFlowWrapper}
      setReactFlowInstance={setReactFlowInstance}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      onClickConnectEdge={onClickConnectEdge}
      onClickUpdateEdge={onClickUpdateEdge}
      onDropNode={onDropNode}
      onDragNode={onDragNode}
    />
  );
}


export default Board;